import React from "react";
import { cn } from "../../utls/utils";
import Typography from "../typography";

export type LogoSize = "xs" | "sm" | "md" | "lg" | "xl";

interface LogoProps {
  size?: LogoSize;
  className?: string;
  showText?: boolean;
  imageOnly?: boolean;
  textOnly?: boolean;
  textClassName?: string;
  imageClassName?: string;
}

// Size configuration for both image and text
const sizesConfig = {
  xs: {
    image: "h-6 w-auto",
    text: "text-sm",
    spacing: "ml-2",
    container: "gap-2",
  },
  sm: {
    image: "h-8 w-auto",
    text: "text-md",
    spacing: "ml-2",
    container: "gap-1",
  },
  md: {
    image: "h-10 w-auto",
    text: "text-lg",
    spacing: "ml-3",
    container: "gap-2",
  },
  lg: {
    image: "h-12 w-auto",
    text: "text-xl",
    spacing: "ml-3",
    container: "gap-3",
  },
  xl: {
    image: "h-16 w-auto",
    text: "text-2xl",
    spacing: "ml-4",
    container: "gap-4",
  },
};

export const Logo: React.FC<LogoProps> = ({
  size = "md",
  className = "",
  showText = true,
  imageOnly = false,
  textOnly = false,
  textClassName = "",
  imageClassName = "",
}) => {
  // Prevent contradictory props
  if (imageOnly && textOnly) {
    console.warn(
      "Logo component cannot have both imageOnly and textOnly set to true"
    );
    imageOnly = false;
    textOnly = false;
  }

  // Get configuration based on size
  const config = sizesConfig[size];

  return (
    <div className={cn("flex items-center", config.container, className)}>
      {!textOnly && (
        <img
          src={`${process.env.PUBLIC_URL}/images/harper-logo.png`}
          className={cn(config.image, imageClassName)}
          alt="Harper Logo"
        />
      )}

      {showText && !imageOnly && (
        <Typography
          variant={size === "xs" ? "body2" : size === "sm" ? "body1" : "h5"}
          className={cn(
            config.spacing,
            "text-primary font-bold tracking-wide",
            "font-handwriting",
            textClassName
          )}
        >
          Harper
        </Typography>
      )}
    </div>
  );
};

export default Logo;
